import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import {
  Button,
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Jumbotron,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import axios from "axios";

interface WelcomeProps {
  isAuthenticated: boolean;
  authButtonMethod: any;
  user: any;
}

interface WelcomeState {
  isOpen: boolean;
  adminList: Array<string>;
}

function WelcomeContent(props: WelcomeProps) {


  // If authenticated, greet the user
  if (props.isAuthenticated) {
    return (
      <div>
       <hr className="borderwhite2"/>
       <h2>Welcome {props.user.displayName}!, Click on any of the buttons below to get started.</h2>   
        <div>
          <div className="row">
            <div className="col-md-10 center-block pt-40">
              <div className="row">  
                <div className="col-md-6 ">
                  <div className="borderblockhp">
                    <NavLink href={'/OnlineJobs'} className=" mediumtext overlaytext podlink" >
                    <img src="img/icon_jobs.png" className="imghpblock"/>
                    Online Jobs</NavLink>
                  </div>
                </div>
                
                
                <div className="col-md-6 ">
                  <div className="borderblockhp">
                    <NavLink href={'/Administration'} className=" mediumtext overlaytext podlink" >
                    <img src="img/icon_doc.png" className="imghpblock"/>
                    Administration</NavLink>
                  </div>
                </div>
  
              </div>
            
              <div className="clearfix">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Not authenticated, present a sign in button
  return <Button color="primary" className="buttonblockarea" onClick={props.authButtonMethod}>Click here to sign in</Button>;
}

function WelcomeContent2(props: WelcomeProps) {


  // If authenticated, greet the user
  if (props.isAuthenticated) {
    return (
      <div>
       <hr className="borderwhite2"/>
       <h2>Welcome {props.user.displayName}!, Click on any of the buttons below to get started.</h2>   
        <div>
          <div className="row">
            <div className="col-md-10 center-block pt-40">
              <div className="row">  
                <div className="col-md-6 ">
                  <div className="borderblockhp">
                    <NavLink href={'/OnlineJobs'} className=" mediumtext overlaytext podlink" >
                    <img src="img/icon_jobs.png" className="imghpblock"/>
                    Online Jobs</NavLink>
                  </div>
                </div>
                
                
               
  
              </div>
            
              <div className="clearfix">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Not authenticated, present a sign in button
  return <Button color="primary" className="buttonblockarea" onClick={props.authButtonMethod}>Click here to sign in</Button>;
}

export default class Welcome extends React.Component<WelcomeProps, WelcomeState> {
  constructor(props: WelcomeProps) {
    super(props);
    this.state = {
      isOpen: false,
      adminList: []
    };
  }
  componentDidMount() {
    var url = "https://encontech.azurewebsites.net/api/admins";
    //var url = "http://localhost:5000/api/admins";

    axios.get(url).then((response) => {
      
      var al = response.data.map(function(admin: { id: number, email:string }) {
        return admin.email;
      });
  console.log("AL WELCOME:" + al);
        this.setState({
          adminList: al
        });

        console.log("AL WELCOME LIST:" + this.state.adminList);
    });
  }

  render() {

    let WelcomeLink = null;
    let WelcomeLink2 = null;
    var isAdmin = this.state.adminList.includes(this.props.user.email);
    console.log("WELCOME AdminList: " + this.state.adminList)
    console.log("WELCOME Is Admin: " + isAdmin);
    
    
   WelcomeLink = (<div></div>)
    
      WelcomeLink2 = (
        <WelcomeContent2
                    isAuthenticated={this.props.isAuthenticated}
                    user={this.props.user}
                    authButtonMethod={this.props.authButtonMethod} 
                    /> 
      );
    


    const divStyle = {
      backgroundImage: 'url(img/enconhp01.jpg)',
      backgroundSize: '100%'
      };
    if(isAdmin)
    {
    return (
      <div>
        <div className="animated fadeIn websitepages ">
          <div className="overlay"></div>
          <div className="parallaximage aboutimg text-center  whitetext  hpheroimage  " style={divStyle}>
            <div className="container">
              <div className="col-lg-12 col-md-12 col-sm-12 headerareas overlaytext center-block">
                <div className="center-block ">
                  <h1 className="sans_fontheader xxltext xxltext-md  overlaytext font-weight-bold">Encon Client Administration Portal</h1>
                  <h2 className="largetext   plrxs-50 mb-20 mobile16 overlaytext font-weight-normal">The purpose of this portal is to provide control and service technicians with tools and resources to administrate over client sites. </h2>
                  <WelcomeContent
    isAuthenticated={this.props.isAuthenticated}
    user={this.props.user}
    authButtonMethod={this.props.authButtonMethod} 
    />
                  <div className="clearfixblock"></div>
                </div>
              </div>
              <div className="clearfixblock"></div>
            </div>
          </div>
        </div>
      </div>  );
  }
  else
  {
    return (
      <div>
        <div className="animated fadeIn websitepages ">
          <div className="overlay"></div>
          <div className="parallaximage aboutimg text-center  whitetext  hpheroimage  " style={divStyle}>
            <div className="container">
              <div className="col-lg-12 col-md-12 col-sm-12 headerareas overlaytext center-block">
                <div className="center-block ">
                  <h1 className="sans_fontheader xxltext xxltext-md  overlaytext font-weight-bold">Encon Client Administration Portal</h1>
                  <h2 className="largetext   plrxs-50 mb-20 mobile16 overlaytext font-weight-normal">The purpose of this portal is to provide control and service technicians with tools and resources to administrate over client sites. </h2>
                  <WelcomeContent2
    isAuthenticated={this.props.isAuthenticated}
    user={this.props.user}
    authButtonMethod={this.props.authButtonMethod} 
    />
                  <div className="clearfixblock"></div>
                </div>
              </div>
              <div className="clearfixblock"></div>
            </div>
          </div>
        </div>
      </div>  );
  }
}
}

